import { pipe } from 'fp-ts/lib/function';
import {
  createAuthorizedGetRequest,
  decode,
  fetchApi,
} from '@/services/api';
import { chain } from 'fp-ts/TaskEither';
import { integrationsPublicApiKeyCodec } from '@/services/api/resources/integrations-public-api-key/codec';

const baseUrl = '/v2/integrations/public-api-key';
export const get = () => pipe(
  baseUrl,
  createAuthorizedGetRequest,
  chain(fetchApi),
  chain(decode(integrationsPublicApiKeyCodec)),
);
